import { render, staticRenderFns } from "./MotoboySection.vue?vue&type=template&id=c595c7e4&scoped=true&"
import script from "./MotoboySection.vue?vue&type=script&lang=js&"
export * from "./MotoboySection.vue?vue&type=script&lang=js&"
import style0 from "./MotoboySection.vue?vue&type=style&index=0&id=c595c7e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c595c7e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c595c7e4')) {
      api.createRecord('c595c7e4', component.options)
    } else {
      api.reload('c595c7e4', component.options)
    }
    module.hot.accept("./MotoboySection.vue?vue&type=template&id=c595c7e4&scoped=true&", function () {
      api.rerender('c595c7e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/MotoboySection.vue"
export default component.exports